import { createApiRef } from '@backstage/core-plugin-api';

export interface WireguardPeer {
  id: string;
  name: string;
  address: string;
  enabled: boolean;
  publicKey: string;
  createdAt: string;
  updatedAt: string;
  transferRx: number;
  transferTx: number;
  latestHandshakeAt: string | null;
  persistentKeepalive: string;
  config?: string;
}

export interface WireguardInfo {
  publicKey: string;
  address: string;
  listenPort: number;
}

export interface VpnTestResult {
  connected: boolean;
  reason: string;
  peer?: { name: string; address: string };
  lastHandshake?: string;
}

export interface WireguardApi {
  listPeers(): Promise<WireguardPeer[]>;
  listMyPeers(): Promise<WireguardPeer[]>;
  createPeer(name: string): Promise<WireguardPeer>;
  deletePeer(id: string): Promise<void>;
  deleteMyPeer(id: string): Promise<void>;
  // Rotate keys for one of the caller's own peers. The old peer is deleted
  // and a new one is created with the same name; the new peer gets a NEW
  // auto-allocated IP (wg-easy v15 doesn't let us preserve it). The returned
  // peer includes its fresh `config`.
  regenerateMyPeer(id: string): Promise<WireguardPeer>;
  enablePeer(id: string): Promise<void>;
  disablePeer(id: string): Promise<void>;
  getPeerConfig(id: string): Promise<string>;
  getPeerQrUrl(id: string): string;
  getInfo(): Promise<WireguardInfo>;
  testConnection(): Promise<VpnTestResult>;
  getScriptUrl(name: string): string;
}

export const wireguardApiRef = createApiRef<WireguardApi>({
  id: 'plugin.wireguard',
});
